/**
 *
 * ReceptionForm
 *
 */

import React from 'react';
import AdvancedForm from 'containers/AdvancedForm';
import {
    ON_VISIT,
    ON_CAR_ENTRY,
    ON_PROPERTY_BRINGING,
    ON_PROPERTY_REMOVAL,
    ON_PASS_MAKING,
    SERVICE,
    CARRYING_OUT_WORKS,
} from 'domain/Data/RequestType/constants';
import {CREATED, ON_TERRITORY, REJECTED} from 'domain/Data/RequestStatus/constants';
import {PASSPORT} from 'domain/Data/DocumentType/constants';
import {validateCarNumber} from 'utils/validators';
import {RECEPTION_REQUESTS_FORM} from './constants';
import {getValueFromLocalStorage} from 'utils/localStorage';
import {GLOBAL_USER_KEY} from 'global-constants';
import {REQUESTS} from 'domain/Data/constants';
import {COMPANY_ARCHIVE_STATUS} from 'pages/Companies/ReceptionView/constants';
import {formField} from 'domain/typeConstants/form';
import * as entities from 'domain/Data/constants';
import {groupRequestVisitorsDataHelperText, visitorFullNameLabel} from '../common/fields';

class ReceptionForm extends React.PureComponent {

    getFields() {
        const currentDate = new Date();

        return [
            {
                name: 'author',
                visible: false,
                initialValue: (values, mode, user) => user.id,
            },
            {
                name: 'arrivalDate',
                type: 'date',
                visible: false,
                calculatedValue: (values, mode) => {
                    if ((mode === 'add' || mode === 'copy') && values.type === ON_VISIT) {
                        return currentDate
                    }
                    if (mode === 'edit' && values.type === ON_VISIT && values.passNumber) {
                        return currentDate
                    }
                    return null
                }
            },
            {
                name: 'departureDate',
                visible: false,
                initialValue: () => null,
            },
            {
                name: 'number',
                label: '№',
                visible: (currentValues, initialValues, mode) => mode === 'edit',
                disabled: true,
            },
            {
                name: 'status',
                type: 'select',
                label: 'Статус',
                entityName: 'requestStatuses',
                visible: (currentValues, initialValues, mode) => mode === 'edit',
                calculatedValue: (values, mode) => {
                    if (mode === 'add' || mode === 'copy') {
                        return values.type === ON_VISIT ? ON_TERRITORY : CREATED;
                    }

                    return values.status;
                },
                visibleOptions: (currentValues, initialValues, mode, user, entities) => {
                    const status = entities.get('requestStatuses').valueSeq().toJS();
                    if (status && (currentValues.status === REJECTED || currentValues.status === CREATED)) {
                        return status.filter(item => item.id !== ON_TERRITORY).map((item) => item.id);
                    }
                },
                orderBy: 'name',
            },
            {
                name: 'type',
                type: 'select',
                label: 'Вид',
                required: true,
                entityName: 'requestTypes',
                initialValue: (values, mode) => {
                    if (mode === 'add') {
                        return ON_VISIT;
                    }
                    return values.type;
                },
                orderBy: 'order',
                clearErrorsOnChange: true,
            },
            {
                name: 'longterm',
                type: 'checkbox',
                label: 'Долгосрочная',
                visible: (values) => values.type !== SERVICE,
            },
            {
                name: 'visitDate',
                type: 'date',
                label: 'Дата',
                required: true,
                visible: (currentValues, initialValues, mode) => mode === 'view' || currentValues.type !== SERVICE,
                initialValue: () => {
                    let visitDate = new Date(currentDate.getTime());
                    visitDate.setHours(15);
                    visitDate.setMinutes(0);
                    visitDate.setSeconds(0);
                    return visitDate
                },
                min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate ?
                    new Date(initialValues.visitDate) : currentDate,
                disabled: (currentValues) => currentValues.type === SERVICE,
            },
            {
                name: 'expirationDate',
                type: 'date',
                label: 'Дата окончания',
                required: (values) => values.longterm,
                visible: (values) => values.longterm && values.type !== SERVICE,
                initialValue: (values, mode) => {
                    if (mode === 'copy') {
                        if (new Date(values.expirationDate) > currentDate) {
                            return new Date(values.expirationDate)
                        } else {
                            let expirationDate = new Date(currentDate.getTime());
                            expirationDate.setHours(15);
                            expirationDate.setMinutes(0);
                            expirationDate.setSeconds(0);
                            return expirationDate
                        }
                    }
                    return null;
                },
                calculatedValue: (values) => values.longterm ? values.expirationDate : null,
                min: (values) => new Date(values.visitDate) < currentDate ?
                    new Date(values.visitDate) : currentDate,
            },
            {
                name: 'isGroupRequest',
                type: 'checkbox',
                label: 'Групповая заявка',
                rowBreakBefore: (values) => values.type !== SERVICE,
                visible: (values) => [ON_VISIT, ON_CAR_ENTRY, CARRYING_OUT_WORKS].includes(values.type),
            },
            {
                name: 'groupRequestVisitorsData',
                label: 'Список посетителей',
                multiline: true,
                helperText: groupRequestVisitorsDataHelperText(),
                visible: (values) => values.isGroupRequest && values.type !== SERVICE,
                required: (values) => values.isGroupRequest && values.type === ON_VISIT,
                grid: {sm: 12},
                rowBreakBefore: (values) => values.isGroupRequest && values.type !== SERVICE,
            },
            {
                name: 'workType',
                label: 'Вид',
                type: formField.SELECT,
                entityName: entities.WORK_TYPES,
                visible: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakAfter: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'companyName',
                label: (values) => values.type === CARRYING_OUT_WORKS ? 'Подрядчик' : 'Из какой компании',
                visible: (values) => values.type !== SERVICE
                    && values.type !== ON_PASS_MAKING
                    && values.type !== ON_PROPERTY_BRINGING
                    && values.type !== ON_PROPERTY_REMOVAL
            },
            {
                name: 'responsibleFromContractor',
                label: 'Ответственный от подрядчика',
                visible: (values) => values.type === CARRYING_OUT_WORKS,
                required: true,
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'responsibleFromContractorPhone',
                label: 'Телефон отв. подрядчика',
                visible: (values) => values.type === CARRYING_OUT_WORKS,
                required: true,
            },
            {
                name: 'visitorFullName',
                label: visitorFullNameLabel,
                type: 'dadata',
                dadataType: 'NAME',
                dadataParts: ['SURNAME', 'NAME', 'PATRONYMIC'],
                autoFocus: (currentValues, initialValues, mode) => mode === 'add',
                visible: (values) => !values.isGroupRequest && values.type !== SERVICE && values.type !== CARRYING_OUT_WORKS,
                required: (values) => !values.isGroupRequest && values.type === ON_VISIT,
                rowBreakBefore: (values) => !values.isGroupRequest && values.type !== SERVICE,
            },
            {
                name: 'company',
                type: 'autocomplete',
                label: 'Арендатор',
                entityName: 'companies',
                filterBy: `!status.name.contains("${COMPANY_ARCHIVE_STATUS}") or (status = null)`,
                orderBy: 'name',
                numberInQueueFromEnd: 1,
                initialValue: (values, mode, user) => user.companyId,
                rowBreakAfter: (values) => values.type === ON_VISIT ||
                    values.type === ON_CAR_ENTRY || values.type === ON_PASS_MAKING ||
                    values.type === SERVICE,
                required: true,
            },
            {
                name: 'nonstandardCarNumber',
                type: 'checkbox',
                label: 'Нестандартный № авто',
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakAfter: (values) => [ON_CAR_ENTRY, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL, CARRYING_OUT_WORKS].includes(values.type),
                visible: (values) => [ON_CAR_ENTRY, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL, CARRYING_OUT_WORKS].includes(values.type)
                    && !values.isGroupRequest,
            },
            {
                name: 'documentType',
                type: 'select',
                label: 'Вид документа',
                initialValue: PASSPORT,
                entityName: 'documentTypes',
                visible: (values) => values.type !== ON_CAR_ENTRY && values.type !== SERVICE && values.type !== CARRYING_OUT_WORKS
                    && values.type !== ON_PROPERTY_BRINGING && values.type !== ON_PROPERTY_REMOVAL
                    && values.type !== ON_PASS_MAKING && !values.isGroupRequest,
                calculatedValue: (values) => values.isGroupRequest ? PASSPORT : values.documentType,
                rowBreakBefore: true,
            },
            {
                name: 'documentDetails',
                label: 'Серия, № документа',
                visible: (values) => !values.isGroupRequest && values.type !== ON_CAR_ENTRY && values.type !== CARRYING_OUT_WORKS
                    && values.type !== SERVICE && values.type !== ON_PROPERTY_BRINGING && values.type !== ON_PROPERTY_REMOVAL
                    && values.type !== ON_PASS_MAKING,
            },
            {
                name: 'passNumber',
                label: '№ пропуска',
                visible: (values) => values.type === ON_VISIT,
                initialValue: () => null,
            },
            {
                name: 'carNumber',
                label: '№ автомобиля',
                required: (values) => values.type === ON_CAR_ENTRY && !values.isGroupRequest,
                visible: (values) => ([ON_CAR_ENTRY, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL, CARRYING_OUT_WORKS].includes(values.type)) &&
                    !values.isGroupRequest,
                normalize: (value) => value ? value.replace(' ', '') : value,
                validate: validateCarNumber,
                rowBreakBefore: true,
            },
            {
                name: 'carModelText',
                label: 'Марка автомобиля',
                visible: (values) => ([ON_CAR_ENTRY, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL, CARRYING_OUT_WORKS].includes(values.type)) &&
                    !values.isGroupRequest,
            },
            {
                name: 'parking',
                type: 'select',
                label: 'Парковка',
                entityName: 'parkings',
                visible: (values) => [ON_CAR_ENTRY, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL].includes(values.type),
                rowBreakBefore: true,
            },
            {
                name: 'parkingPlace',
                label: '№ места',
                visible: (values) => values.type !== ON_VISIT && values.type !== ON_PASS_MAKING && values.type !== SERVICE
                    && values.type !== CARRYING_OUT_WORKS,
                initialValue: () => null,
            },
            {
                name: 'materialValuesData',
                label: 'Данные мат. ценностей',
                helperText: 'наименование, кол-во, ед.изм.',
                grid: {sm: 12},
                required: true,
                visible: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
            },
            {
                name: 'whoMeets',
                label: 'Кто встречает',
                visible: (values) => values.type === ON_VISIT,
                rowBreakBefore: true,
            },
            {
                name: 'service',
                type: 'select',
                label: 'Сервис',
                entityName: 'services',
                visible: (values) => values.type === SERVICE,
                rowBreakBefore: true,
            },
            {
                name: 'whatHappened',
                label: (values) => values.type === CARRYING_OUT_WORKS ? 'Наименование/Характер работ' : 'Что нужно сделать',
                multiline: false,
                visible: (values) => values.type === SERVICE || values.type === CARRYING_OUT_WORKS,
                grid: {sm: 12},
            },
            {
                name: 'assignee',
                type: 'select',
                label: 'Исполнитель',
                entityName: 'employees',
                orderBy: 'name',
                cached: false,
                visible: (values) => values.type === SERVICE,
                visibleOptions: (currentValues, initialValue, mode, user, entities) => {
                    const assignee = [];
                    entities.get('employees').map((item) => {
                        if (item.isPerformer) assignee.push(item.id);
                    });
                    return assignee;
                },
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.assignee;
                },
            },
            {
                name: 'executionTerm',
                type: 'date',
                label: 'Срок исполнения',
                visible: (values) => values.type === SERVICE,
                min: () => currentDate,
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.executionTerm;
                },
            },
            {
                name: 'executionDate',
                type: 'date',
                label: 'Дата выполнения факт',
                required: true,
                visible: false,
                min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate
                    ? new Date(initialValues.visitDate) : currentDate,
                rowBreakBefore: true,
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.executionDate;
                },
            },
            {
                name: 'whereHappened',
                label: 'Где произошло',
                visible: (values) => values.type === SERVICE,
                rowBreakAfter: true,
            },
            {
                name: 'implementationReport',
                label: 'Отчет о выполнении',
                visible: (values) => values.type === SERVICE,
                grid: {sm: 6},
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.implementationReport;
                },
            },
            {
                name: 'file',
                label: 'Файл',
                type: 'file',
                visible: (values) => values.type === SERVICE || values.type === ON_PASS_MAKING || values.type === CARRYING_OUT_WORKS,
                rowBreakBefore: true,
            },
            {
                name: 'workPlace',
                label: 'Место проведения',
                visible: (values) => values.type === CARRYING_OUT_WORKS,
                required: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'note',
                label: 'Примечание',
                grid: {sm: 12},
                visible: (values) => values.type !== SERVICE,
            },
            {
                name: 'managementCompanyComment',
                label: 'Комментарий УК',
                visible: (values, initialValues, mode) => mode === 'view' || mode === 'edit',
                grid: {sm: 12},
                initialValue: (values, mode) => {
                    if (mode === 'copy') {
                        return null;
                    }
                    return values.managementCompanyComment;
                },
                required: (currentValues) => currentValues.status === REJECTED,
            },
        ];
    }

    getClassNames() {
        return {
            helperText: '',
        };
    }

    render() {
        const accountId = getValueFromLocalStorage(GLOBAL_USER_KEY).accountId
        return (
            <AdvancedForm
                name={RECEPTION_REQUESTS_FORM}
                entityName={REQUESTS}
                classNames={this.getClassNames()}
                fields={this.getFields()}
                accountId={accountId}
                useAsyncValidate
                {...this.props}
            />
        );
    }
}

export default ReceptionForm;
